import { getHeightAvailableConfig } from './getHeightAvailableConfig'

export const unobserveHeightAvailable = (el: HTMLElement) => getHeightAvailableConfig()?.deleteElement(el)
